export * from './assetExecutionStrategySettingsManagementController.service';
import { AssetExecutionStrategySettingsManagementControllerService } from './assetExecutionStrategySettingsManagementController.service';
export * from './fundingRateController.service';
import { FundingRateControllerService } from './fundingRateController.service';
export * from './fundingRatePaymentController.service';
import { FundingRatePaymentControllerService } from './fundingRatePaymentController.service';
export * from './globalRiskSettingsManagementController.service';
import { GlobalRiskSettingsManagementControllerService } from './globalRiskSettingsManagementController.service';
export * from './operatingController.service';
import { OperatingControllerService } from './operatingController.service';
export * from './pairSettingsManagementController.service';
import { PairSettingsManagementControllerService } from './pairSettingsManagementController.service';
export * from './perpetualBalanceController.service';
import { PerpetualBalanceControllerService } from './perpetualBalanceController.service';
export * from './perpetualPairController.service';
import { PerpetualPairControllerService } from './perpetualPairController.service';
export * from './perpetualTradeController.service';
import { PerpetualTradeControllerService } from './perpetualTradeController.service';
export * from './webSocketMessageTypes.service';
import { WebSocketMessageTypesService } from './webSocketMessageTypes.service';
export const APIS = [
  AssetExecutionStrategySettingsManagementControllerService,
  FundingRateControllerService,
  FundingRatePaymentControllerService,
  GlobalRiskSettingsManagementControllerService,
  OperatingControllerService,
  PairSettingsManagementControllerService,
  PerpetualBalanceControllerService,
  PerpetualPairControllerService,
  PerpetualTradeControllerService,
  WebSocketMessageTypesService,
];
